// extracted by mini-css-extract-plugin
module.exports = {"header":"PageHeader_header__qAjE6","title":"PageHeader_title__16GkS"};